import React, { FC } from "react";
import { ListItemButton, ListItemButtonProps } from "@mui/material"

const ListItemButtonWrapper: FC<ListItemButtonProps> = ({...props}) => <ListItemButton {...props}/>

export default ListItemButtonWrapper;